export default __webpack_public_path__ + "static/media/hello.76b511f3.svg";